<template>
  <div class="ml-3">
    <div class="ml-md-3 pl-md-2 mr-md-3 mt-md-4 mb-md-4 bg-white">
      <div class="row p-md-2 container-info">
        <div class="col-md-2 col-sm-12">
          <span class="data-title d-block border-mobile">
            Número de Solicitud:
          </span>
          <span class="font-16 color-black">
            {{ data.requestNumber }}
          </span>
        </div>
        <div v-if="data.modality" class="col-md-3 col-sm-12">
          <span class="data-title d-block">Modalidad:</span>
          <span class="font-16 color-black">
            {{ data.modality }}
          </span>
        </div>
        <div v-if="data.frequency" class="col-md-2 col-sm-12">
          <span class="data-title d-block border-mobile">Frecuencia:</span>
          <span class="font-16 color-black">
            {{ data.frequency }}
          </span>
        </div>
        <div v-if="data.duration" class="col-md-2 col-sm-12">
          <span class="data-title d-block border-mobile">Duración :</span>
          <span class="font-16 color-black">
            {{ data.duration }}
          </span>
        </div>

        <div class="col-md-3 col-sm-12">
          <span class="data-title d-block border-mobile">
            Lugar de Servicio:
          </span>
          <span class="font-16 color-black">
            {{ data.locationService | empty }}
          </span>
        </div>
      </div>
      <div class="row p-md-2 container-info">
        <div class="col-12 col-md-2">
          <span class="data-title d-block border-mobile">
            Requiere Transportación
          </span>
          <span class="font-16 color-black">
            {{ requireTransportation }}
          </span>
        </div>
        <div v-if="isEvaluationService" class="col-12 col-md-10">
          <span class="data-title d-block border-mobile">
            Fecha de Discusión:
          </span>
          <span class="font-16 color-black">
            {{ data.discussionDate | date }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AditionalInformation',
  components: {},
  props: {
    data: {
      type: Object,
      default: () => {},
    },
    isEvaluationService: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  computed: {
    requireTransportation() {
      return this.data.requireTransportation ? 'SI' : 'NO';
    },
  },
  methods: {
    openCloseTabs() {
      this.showTabs = !this.showTabs;
    },
  },
};
</script>

<style lang="scss" scoped>
.container-info {
  position: relative;
  top: -15px;
}
.orange-icon {
  color: #ff7058;
}
</style>
